import { CommonExport } from '../common/common-export.service';
import { getLastExportId, setLastExportId } from 'modules/export/storage/last-export.storage';

export class SalesDownloadService extends CommonExport<any> {
  _downloadFileToExcel = (path: string, name?: string) =>
    this.downloadFileToExcel({
      name: name ?? 'orders',
      // Backend already returns the correct relative download path (e.g. 'orders/export/123.xlsx').
      // We only ensure it has a leading '/'.
      path: path.startsWith('/') ? path : `/${path}`,
    });

  // inicial path export
  _getExportPath = async (params: any, path?: string, sort?: any) => {
    const response = await this.getExportPath(path ?? '/orders/export', { ...params, sort });
    if (response?._id) {
      setLastExportId(response._id);
    }
    return response;
  };

  _rememberLastExportId = (id?: string) => {
    if (!id) return;
    setLastExportId(id);
  };

  _getLastExportId = () => {
    return getLastExportId();
  };

  _generateDownload = () => this.generateDownload('/orders/export/');
}

export default new SalesDownloadService('/ms-sales/api');
